var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-bg-container"},[_c('img',{staticStyle:{"width":"100%","height":"100%","object-fit":"cover"},attrs:{"src":_vm.src,"referrerpolicy":"no-referrer"}}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-content"},[_c('p',{staticStyle:{"font-size":"50px","-webkit-text-stroke":"1px black","font-style":"italic"}},[_vm._v("快乐星姬天制作委员会")])])
}]

export { render, staticRenderFns }